import api from '@/utils/api'

export default {
    getLeagueGroups(page, size) {
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get(`league-groups` + (page ? range : ''))
    },

    getLeagueGroup(id) {
        return api.get(`league-groups/${id}`)
    },

    getAllLeagueGroups() {
        return api.get(`league-groups/all`)
    },

    updateLeagueGroup(id, data) {
        return api.put(`league-groups/${id}`, data)
    },

    createLeagueGroup(data) {
        return api.post('league-groups', data)
    },

    deleteLeagueGroup(id) {
        return api.delete(`league-groups/${id}`)
    }
}
